import { Map } from "immutable";
import { change, reduxForm, SubmissionError } from "redux-form/immutable";

import firebaseErrorTranslator, {
  ErrorMessage
} from "services/firebase/auth/errorTranslator";

import { getReferralCodeFromLocation } from "seneca-common/utils/functions/referral";
import { validatePassword } from "seneca-common/utils/functions/validation/password";
import { validateString } from "seneca-common/utils/functions/validation/validateString";
import {
  validateEmailStrictly,
  validatePhoneNumber
} from "seneca-common/utils/functions/validationFunctions";

import { signUp } from "features/user";

import {
  signUpFormName as formName,
  PASSWORD_FIELD_NAME,
  signInFormName,
  USERNAME_FIELD_NAME
} from "../../../const";
import SignUpFormEmail from "./SignUpFormEmail";

const validate = (valuesIn: any) => {
  const {
    firstName,
    lastName,
    [USERNAME_FIELD_NAME]: username,
    phoneNumber,
    [PASSWORD_FIELD_NAME]: password,
    termsAndConditions
  } = valuesIn.toJS();
  return {
    firstName: validateString(firstName),
    lastName: validateString(lastName),
    [USERNAME_FIELD_NAME]: validateEmailStrictly(username),
    phoneNumber: validatePhoneNumber(phoneNumber),
    [PASSWORD_FIELD_NAME]: validatePassword(password),
    termsAndConditions:
      !termsAndConditions && "You must agree to the terms and conditions"
  };
};

// Register both pages of the sign up form to the same reducer object
const withForm = reduxForm({
  form: formName,
  // same form name
  // @ts-ignore
  validate,
  destroyOnUnmount: false,
  // preserve form data
  forceUnregisterOnUnmount: true,
  enableReinitialize: true,
  //  unregister fields on unmount
  onSubmit: async (
    formValues: Map<string, string>,
    dispatch: any,
    props: any
  ) => {
    const userDetails = {
      email: formValues.get(USERNAME_FIELD_NAME),
      phoneNumber: formValues.get("phoneNumber") || "",
      givenName: formValues.get("firstName") || "",
      familyName: formValues.get("lastName") || "",
      ...(props.accountType && { type: props.accountType })
    };

    const password = formValues.get(PASSWORD_FIELD_NAME)!;

    try {
      const referralCode =
        props && (getReferralCodeFromLocation(props.location as any) as string);

      const isSubscribedToMarketingEmails = formValues.get(
        "isSubscribedToMarketingEmails"
      ) as unknown as boolean | undefined;

      await dispatch(
        signUp({
          userDetails,
          password,
          referralCode,
          isSubscribedToMarketingEmails
        })
      );
    } catch (error: any) {
      throw new SubmissionError<{}, ErrorMessage>({
        _error: firebaseErrorTranslator(error)
      });
    }
  },
  onChange: (formValues: any, dispatch) => {
    dispatch(
      change(signInFormName, "username", formValues.get(USERNAME_FIELD_NAME))
    );
    dispatch(
      change(signInFormName, "password", formValues.get(PASSWORD_FIELD_NAME))
    );
  },
  onSubmitSuccess: (userDetails, dispatch, props: any) => {
    const { onSignUpSubmitSuccess } = props;
    onSignUpSubmitSuccess();
  }
});

export default withForm(SignUpFormEmail);
